import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://gcfmhqyjbebvmniccmme.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdjZm1ocXlqYmVidm1uaWNjbW1lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQyNDg2NzEsImV4cCI6MjA4OTgyNDY3MX0.AUyjzPSt1AYYUANnj3FuekMmkQO0jtMvUs-5Gf6n2J0'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})